import axios from 'axios'
import qs from 'qs'
import {getStorage,getCardServerToken} from "./util2.js";
import app from "../../main.js";

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
axios.defaults.timeout =  100000;

axios.interceptors.request.use(function (config) {
  if (config.method === 'post' && 
      (config.url.includes('opApi') || config.url.includes('accountCenter') || config.url.includes('pushdata-java'))
     ) {
      config.data = qs.stringify(config.data);
    }

  if (getStorage('token')) {
    config.headers.Authorization = getStorage('token');
  }

  // 处理数据
  if(config.url.indexOf('rechargeApi')!=-1 || config.url.indexOf('/newiot') !== -1){
    if(config.method==='post'){
      config.headers['Qhyl-Token'] = getCardServerToken(config.data)
    }else if(config.method==='get'){
      config.headers['Qhyl-Token'] = getCardServerToken(config.params)
    }
  }
  config.headers['requestUrl'] = 'http://eq.china-m2m.com'
  return config;  //添加这一行
}, (error) => {
  return Promise.reject(error);
});
axios.interceptors.response.use(function (response) {
  if (response.data.hasOwnProperty('status') && response.data.status !== 1) {
    response.data.msg = app.$t('error.tips_3')
  }
  if (response.data.hasOwnProperty('state') && response.data.state !== 1) {
    response.data.msg = app.$t('error.tips_3')
  }
  return response
}, err => {
  if (Object.prototype.toString.call(err) === '[object object]' || Object.prototype.toString.call(err) === '[object Error]') {
    if (err.message == 'Network Error') return Promise.resolve({
      data: {
        status: 16811
      }
    })
    if (err.response.status && err.response.status === 401 && err.config.url.indexOf('/accountCenter') > -1) {
      return Promise.resolve(err.response);
    } else if (err.response.data.error === 10007 && err.config.url.indexOf('/accountCenter') > -1) {
      return Promise.resolve(err.response)
    } else {
      let msg;
      err.response.status ? msg = app.$t('error.tips_1') + `${err.response.status}` : msg = app.$t('error.tips_2');
      return Promise.resolve({
        status: err.response.status ? err.response.status : 200,
        state: 0,
        msg: msg
      });
    }
  }
});


function _post(url,param){

    return axios({
        method:'post',
        url,
        data:param,
    })
}

function _get(url,param){

    return axios({
        method:'get',
        url,
        params:param,
    })
}

export {_post, _get}

export default function request(url, option) {
    const options = {
      ...option
    }
    if (options.method === "POST") {
      return axios({
        method: "post",
        url,
        data: options.body,
      })
    } else if (options.method === "GET") {
      return axios({
        method: "get",
        url,
        params: options.payload
      })
    }
}